import { Grid, Tooltip } from "@material-ui/core";
import React, { useContext, useEffect } from "react";
import SelectErp from "../../../../components/basics/SelectErp";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { findSituacaoVendas } from "../../../../repositories/qerpapi/erp/vendas/v1/VendasRepository";
import { notify } from "../../../../utils/notify";
import { PainelNfeContext } from "../contexts/PainelNfeContext";

const SelectSituacaoDeVenda = () => {
  const { queryParams } = useContext(QueryParamsContext);

  const {
    setLoadingInputs,
    situationList,
    setSituationList,
    saleSituation,
    setSaleSituation,
    loadingInputs,
  } = useContext(PainelNfeContext);

  useEffect(() => {
    setLoadingInputs((current) => ({
      ...current,
      saleSituation: true,
    }));

    (async () => {
      try {
        const listaSituacoes = await findSituacaoVendas({
          empresa_cnpj: queryParams.empresa_cnpj,
        });

        if (!listaSituacoes.success)
          return notify("Erro ao buscar situações de venda");

        setSaleSituation(
          listaSituacoes.data.find((current) => current.id === 1) || []
        );
        setSituationList(listaSituacoes.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          saleSituation: false,
        }));
      }
    })();
  }, [
    queryParams.empresa_cnpj,
    setSaleSituation,
    setLoadingInputs,
    setSituationList,
  ]);
  //
  return (
    <Grid item xs>
      <Tooltip
        title="Selecione a situação de venda para atualizar as vendas vinculadas à NFe."
        arrow
        placement="top-start"
      >
        <SelectErp
          optionsList={situationList}
          descriptionField="descricao"
          value={saleSituation}
          setValue={setSaleSituation}
          label="Situação da venda"
          loading={loadingInputs.saleSituation || false}
        />
      </Tooltip>
    </Grid>
  );
};

export default SelectSituacaoDeVenda;
